import React, { memo, useState } from 'react';
import { faGear } from '@fortawesome/free-solid-svg-icons';

import { Modal, TabContainer } from '~components';
import ClickableIcon from '~components/ClickableIcon';
import ServiceColour from '~weekly-planner/components/service-colour/ServiceColour';

import { AlertOptions, PlannerOptions, TotalOptions, WorkerOptions } from './settings';

interface ComponentProps {
  showCancellations: boolean;
  changeOptions: (options: Array<{ value: boolean; parameterKey: string; optionKey: string }>) => void;
  showPayableCancellations: boolean;
  workerQualifications: boolean;
  dispatch: any;
  workerAvailability: boolean;
  viewType: string;
  appointmentFlexibility: boolean;
  showSystemUsers: boolean;
  showServiceType: boolean;
  showBreaks: boolean;
  showTeaBreaks: boolean;
  showTravel: boolean;
  showCardQualifications: boolean;
  workerAwardAlerts: boolean;
  totalSimple: boolean;
  totalAppointments: boolean;
  totalPredicted: boolean;
  totalDistance: boolean;
  refresh: () => void;
}

const settingsModal: React.FC<ComponentProps> = ({
  showCancellations,
  changeOptions,
  showPayableCancellations,
  workerQualifications,
  viewType,
  appointmentFlexibility,
  showSystemUsers,
  showServiceType,
  showBreaks,
  showTeaBreaks,
  showTravel,
  showCardQualifications,
  workerAwardAlerts,
  totalSimple,
  totalAppointments,
  workerAvailability,
  totalPredicted,
  totalDistance,
  refresh,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [serviceColourModalOpen, setServiceColourModalOpen] = useState(false);

  const handleEditServiceColors = () => {
    setModalOpen(false);
    setServiceColourModalOpen(true);
  };

  const tabs = [
    {
      id: 'planner',
      title: 'Planner',
      component: memo(function PlannerOptionsTab() {
        return PlannerOptions({
          appointmentFlexibility,
          showSystemUsers,
          showBreaks,
          showTeaBreaks,
          showTravel,
          showCancellations,
          showPayableCancellations,
          showServiceType,
          showCardQualifications,
          changeOptions,
          refresh,
          setModalOpen,
        });
      }),
    },
    {
      id: 'worker-options',
      title: 'Worker Options',
      component: memo(function WorkerOptionsTab() {
        return WorkerOptions({
          workerQualifications,
          workerAvailability,
          viewType,
        });
      }),
    },
    {
      id: 'alerts',
      title: 'Alerts',
      component: memo(function AlertOptionsTab() {
        return AlertOptions({
          workerAwardAlerts,
        });
      }),
    },
    {
      id: 'totals',
      title: 'Totals',
      component: memo(function TotalOptionsTab() {
        return TotalOptions({
          totalSimple,
          totalAppointments,
          totalPredicted,
          totalDistance,
        });
      }),
    },
    {
      id: 'admin',
      title: 'Admin Options',
      component: memo(function AdminOptionsTab() {
        return (
          <div className="p-4">
            <h5 className="mb-3">Service Colors</h5>
            <button className="btn btn-primary" onClick={handleEditServiceColors} data-cy="edit-service-colors-button">
              Edit Service Colors
            </button>
          </div>
        );
      }),
    },
  ];

  return (
    <>
      <div className="mx-1">
        <ClickableIcon id="settings-toggle" icon={faGear} toolTip="Settings" onClick={() => setModalOpen(true)} />
      </div>

      <Modal
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        header="Weekly Planner Settings"
        size="lg"
        className="weekly-planner-settings-modal"
        includeFooter={false}
        data-cy="weekly-planner-settings-modal"
      >
        <TabContainer tabs={tabs} />
      </Modal>

      {/* Service Color Modal */}
      <ServiceColour isOpen={serviceColourModalOpen} onClose={() => setServiceColourModalOpen(false)} />
    </>
  );
};

export default settingsModal;
